import angular from 'angular';

import AppUsageModule from './app-usage/app-usage';
import OrdersModule from './orders/orders';

const ComponentsModule = angular.module('control-room.reports.components', [AppUsageModule.name, OrdersModule.name]);

export default ComponentsModule;
